module.exports = __webpack_public_path__ + "img/quotes_white.7f4c177e.svg";